import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#667085",
        d: "m8 16.32-4.243-4.243a6 6 0 1 1 8.486 0zm3.3-5.186a4.667 4.667 0 1 0-6.6 0l3.3 3.3zM8 9.167a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .5h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }